export default "__VITE_ASSET__xlb7OlHD__"